import { call, put } from 'redux-saga/effects';
import * as actions from './meeting-templates.actions';
import * as meetingTemplateResource from '../../../resource/meeting-templates/meeting-templates.saga-service';
import { IMeetingTemplate } from '../../../resource/meeting-templates/meeting-templates.types';

export function* fetchMeetingTemplates() {
  const meetingTemplates = (yield call(meetingTemplateResource.fetchMeetingTemplates)) as IMeetingTemplate[];

  yield put(actions.storeMeetingTemplateIds(meetingTemplates.map((meetingTemplate) => meetingTemplate.id)));
}
